import { transformExtent } from 'ol/proj'
export const MAP_ZOOM = 6.5
export const MAP_ZOOM_MOBILE = 6
export const MAP_CENTER = [74.7, 41.6] //transform([42, 47], "EPSG:4326", "EPSG:3857");

export const COLOR_SEA = '#fff'
export const COLOR_LAND = '#efeeed'
//export const COLOR_ORANGE = '#f0d5c2'
export const BlueMarker = `data:image/svg+xml;utf8,${encodeURIComponent(`<?xml version="1.0" encoding="iso-8859-1"?>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="34" height="50" viewBox="0 0 34 50">
    <path style="opacity:0.2;fill:#083d77;fill-opacity:0;stroke:#000000;stroke-width:2;stroke-miterlimit:10;" d="M17,1C8.2,1,1,8.2,1,17c0,2.6,0.7,5.1,1.8,7.4l0.1,0.1c0.1,0.2,0.3,0.4,0.4,0.6L17,49l13.4-23.3
    C32,23.2,33,20.2,33,17C33,8.2,25.8,1,17,1z"/>
  <path style="fill:#083d77;" d="M17,49l13.4-23.3C32,23.2,33,20.2,33,17c0-8.8-7.2-16-16-16S1,8.2,1,17c0,2.6,0.7,5.1,1.8,7.4l0,0l0.1,0.1
    c0.1,0.2,0.3,0.4,0.4,0.6L17,49z M17,9c4.4,0,8,3.6,8,8s-3.6,8-8,8s-8-3.6-8-8S12.6,9,17,9z"/>
  <circle style="fill:#083d77;fill-opacity:0.05;" cx="17" cy="17" r="8"/>
    </svg>
    `)}`

const kyrgyzstanExtent4326: [number, number, number, number] = [
  69.2, 39.18, 80.3, 44.3,
]
export const kyrgyzstanExtent3857 = transformExtent(
  kyrgyzstanExtent4326,
  'EPSG:4326',
  'EPSG:3857'
)

type PlaceInfo = {
  city: string
  id: number
  lat: number
  lng: number
  phone: string
}
export const info: PlaceInfo[] = [
  {
    city: '«Аялзат»',
    id: 0,
    lat: 42.875969,
    lng: 74.603701,
    phone: '0312653738, 0707653738',
  },
  {
    city: '«Шанс»',
    id: 1,
    lat: 42.876571,
    lng: 74.598536,
    phone: '	0709710320, 0555900698,0312613227',
  },
  {
    city: '«Сезим»',
    id: 2,
    lat: 42.86621,
    lng: 74.585789,
    phone: '	0312512640, 0312316466,0551316466, 0312512640, 0501512640',
  },
  {
    city: '«Аруулан»',
    id: 3,
    lat: 40.514645,
    lng: 72.80672,
    phone: '	0322255608, 0557777405',
  },
  {
    city: '«Ак журок»',
    id: 4,
    lat: 40.514646,
    lng: 72.806721,
    phone: '	0550231329, 0322245976,0779231329',
  },
  {
    city: '«Энсан Диамонд»',
    id: 5,
    lat: 40.514645,
    lng: 72.80672,
    phone: '	0322222965, 0772328960,0552131507',
  },
  {
    city: '«Акылкарачач»',
    id: 6,
    lat: 40.30988,
    lng: 73.437697,
    phone: '	0555281423, 0776281423',
  },
  {
    city: '«Мээрбан»',
    id: 7,
    lat: 40.527965,
    lng: 72.797602,
    phone: '	0773843461',
  },
  {
    city: '«Аялзат – развитие женских инициатив»',
    id: 8,
    lat: 42.491569,
    lng: 78.396676,
    phone: '	0392251091, 0553835717',
  },
  {
    city: '«Алтынай»',
    id: 9,
    lat: 42.649742,
    lng: 77.085755,
    phone: '	0706309886, 0550103088',
  },
  {
    city: '«Химая»',
    id: 10,
    lat: 42.490246,
    lng: 78.396541,
    phone: '	0392253417, 0555204847, 0551733390',
  },
  {
    city: '«Мээрман»',
    id: 11,
    lat: 42.491144,
    lng: 78.399568,
    phone: '	0706383637',
  },
  {
    city: '«Бактылуу эне»',
    id: 12,
    lat: 42.457627,
    lng: 76.187449,
    phone: '	0702748928',
  },
  {
    city: '«Тендеш»',
    id: 13,
    lat: 41.42833,
    lng: 75.997635,
    phone: '	0708747274, 0700257890, 0556218584',
  },
  {
    city: '«Асылзат»',
    id: 14,
    lat: 41.565586,
    lng: 75.852036,
    phone: '	0705447035, 0555447035',
  },
  {
    city: '«Каниет»',
    id: 15,
    lat: 40.943451,
    lng: 72.986096,
    phone: '	0372222303, 0774855227,0550757772',
  },
  {
    city: '«Маана»',
    id: 16,
    lat: 42.526801,
    lng: 72.248354,
    phone: '	0557484713',
  },
  {
    city: '«Ак-Ниет»',
    id: 17,
    lat: 42.819791,
    lng: 73.844014,
    phone: '	0703911769, 0550902955',
  },
]
